import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PlanningHeader() {
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-card px-4">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/start" className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to main
          </Link>
        </Button>
        <div className="h-5 w-px bg-border" />
        <h1 className="text-sm font-semibold text-foreground">WePlanning</h1>
      </div>
    </header>
  );
}
